export const AUDITION_NEXT_SAMPLE = 'AUDITION_NEXT_SAMPLE'
export const AUDITION_PREVIOUS_SAMPLE = 'AUDITION_PREVIOUS_SAMPLE'
export const TRIGGER_SAMPLE = 'TRIGGER_SAMPLE'
export const RELEASE_SAMPLE = 'RELEASE_SAMPLE'
